// gameUtils.js

export function getOrderOfNames(readyPlayers) {
  if (readyPlayers.length < 4) throw new Error('Four ready players are required.');
  const rounds = readyPlayers.length >= 6 ? 2 : 3;
  const guessers = [], thinkers = [];
  for (let round = 0; round < rounds; round++) {
    const names = shuffleArray(readyPlayers.map(p => p.name));
    for (let i = 0; i < names.length; i++) {
      thinkers.push([names[i], names[(i + 1) % names.length]]);
      guessers.push(names[(i + 2) % names.length]);
    }
  }
  return { guessers, thinkers };
}

function shuffleArray(array) {
  // Shuffle logic
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}

export function getOrderOfPrompts(readyPlayers, orderOfNames) {
  const count = readyPlayers.length >= 6 ? 2 : 3;
  const cards = shuffleArray(readyPlayers.flatMap(p => p.unusedPrompts.slice(0, count).filter(Boolean).map(text => ({ text, author: p.name }))));
  const assigned = Array(cards.length).fill(-1);
  // Match each slot to a unique card whose author is not the guesser.
  // Reassign earlier matches when needed, avoiding an empty final card.
  function match(slot, visited) {
    for (let c = 0; c < cards.length; c++) {
      if (visited.has(c) || cards[c].author === orderOfNames.guessers[slot]) continue;
      visited.add(c);
      if (assigned[c] === -1 || match(assigned[c], visited)) { assigned[c] = slot; return true; }
    }
    return false;
  }
  for (let slot = 0; slot < orderOfNames.guessers.length; slot++) {
    if (!match(slot, new Set())) throw new Error('Every player needs enough unique prompts.');
  }
  const result = [];
  assigned.forEach((slot, card) => { if (slot >= 0) result[slot] = cards[card].text; });
  return result;
}

export function selectPrompt(urlGameCode) {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  const storedOrderOfPrompts = storedLocalData && storedLocalData.orderOfPrompts;
  const storedCurrentPlayerIndex = storedLocalData && storedLocalData.currentPlayerIndex;
  const prompt = storedOrderOfPrompts[storedCurrentPlayerIndex];

  return prompt;
}

export function selectPrevPrompt(urlGameCode) {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  const storedOrderOfPrompts = storedLocalData && storedLocalData.orderOfPrompts;
  const storedCurrentPlayerIndex = storedLocalData && storedLocalData.currentPlayerIndex;
  const prompt = storedOrderOfPrompts[storedCurrentPlayerIndex - 1];

  return prompt;
}

export function getThinkersNames(urlGameCode) {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  const storedOrderOfNames = storedLocalData && storedLocalData.orderOfNames;
  const storedCurrentPlayerIndex = storedLocalData && storedLocalData.currentPlayerIndex;
  const currentThinkers = storedOrderOfNames.thinkers[storedCurrentPlayerIndex];

  return currentThinkers;
}

export function getPrevThinkersNames(urlGameCode) {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  const storedOrderOfNames = storedLocalData && storedLocalData.orderOfNames;
  const storedCurrentPlayerIndex = storedLocalData && storedLocalData.currentPlayerIndex;
  const currentThinkers = storedOrderOfNames.thinkers[storedCurrentPlayerIndex - 1];

  return currentThinkers;
}

export function getGuessersName(urlGameCode) {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  const storedOrderOfNames = storedLocalData && storedLocalData.orderOfNames;
  const storedCurrentGuesserIndex = storedLocalData && storedLocalData.currentGuesserIndex;
  const currentGuesser = storedOrderOfNames.guessers[storedCurrentGuesserIndex];

  return currentGuesser;
}

export function getPrevGuessersName(urlGameCode) {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  const storedOrderOfNames = storedLocalData && storedLocalData.orderOfNames;
  const storedCurrentGuesserIndex = storedLocalData && storedLocalData.currentGuesserIndex;
  const currentGuesser = storedOrderOfNames.guessers[storedCurrentGuesserIndex - 1];

  return currentGuesser;
}

export function updatePlayerScore(points, urlGameCode) {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  let storedReadyPlayers = storedLocalData && storedLocalData.readyPlayers;

  const guessersName = getGuessersName(urlGameCode);
  console.log('guessersName: ', guessersName);

  const updatedGamePlayers = storedReadyPlayers.map(player => {
    return { ...player };
  });

  for (let i = 0; i < updatedGamePlayers.length; i++) {
    if (updatedGamePlayers[i].name === guessersName) {
      updatedGamePlayers[i].score += points;
      break;
    }
  }

  storedLocalData.readyPlayers = updatedGamePlayers;
  localStorage.setItem(urlGameCode + '_data', JSON.stringify(storedLocalData));

  addScoreHistory(urlGameCode, points);

}

function addScoreHistory(urlGameCode, points) {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  let storedScoreHistory = storedLocalData && storedLocalData.scoreHistory;

  if (!Array.isArray(storedScoreHistory)) {
    storedScoreHistory = [];
  }

  const updatedScoreHistory = [...storedScoreHistory, points];

  storedLocalData.scoreHistory = updatedScoreHistory;
  localStorage.setItem(urlGameCode + '_data', JSON.stringify(storedLocalData));
}

export function undoLastScoreUpdate(urlGameCode, prevGuesser) {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));

  // Get the scoreHistory array from local storage
  const storedScoreHistory = storedLocalData && storedLocalData.scoreHistory;

  // Check if storedScoreHistory exists and has at least one entry
  if (Array.isArray(storedScoreHistory) && storedScoreHistory.length > 0) {
    // Get the last score from the scoreHistory array
    const lastScore = storedScoreHistory[storedScoreHistory.length - 1];

    // Create a copy of the storedReadyPlayers array
    let storedReadyPlayers = storedLocalData && storedLocalData.readyPlayers;
    // let storedReadyPlayers = JSON.parse(localStorage.getItem(urlGameCode + '_readyPlayers'));
    storedReadyPlayers = storedReadyPlayers.map(player => ({ ...player }));

    // Subtract the last score from the points of the prevGuesser
    for (let i = 0; i < storedReadyPlayers.length; i++) {
      if (storedReadyPlayers[i].name === prevGuesser) {
        storedReadyPlayers[i].score -= lastScore;
        break;
      }
    }

    // Remove the last score from the scoreHistory array
    storedScoreHistory.pop();

    // Update the local storage with the updated values
    storedLocalData.readyPlayers = storedReadyPlayers;
    storedLocalData.scoreHistory = storedScoreHistory;
    localStorage.setItem(urlGameCode + '_data', JSON.stringify(storedLocalData));
  }
}

export function getNumOfCards(urlGameCode) {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  const storedOrderOfPrompts = storedLocalData && storedLocalData.orderOfPrompts;
  // const storedOrderOfPrompts = JSON.parse(localStorage.getItem(urlGameCode + '_orderOfPrompts'));
  const numOfCards = storedOrderOfPrompts.length * 2;
  return numOfCards;
}




/////////////////////////////////////
/////////// RESULTS CARD ////////////
/////////////////////////////////////

export const sortPlayers = urlGameCode => {
  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  const storedReadyPlayers = storedLocalData && storedLocalData.readyPlayers;

  const playersCopy = storedReadyPlayers.map(player => {
    return { ...player };
  });

  playersCopy.sort((a, b) => b.score - a.score);
  return playersCopy;
};

export const addRankings = players => {
  players.forEach((player, index) => {
    if (index > 0 && player.score === players[index - 1].score) {
      player.ranking = players[index - 1].ranking;
    } else {
      player.ranking = index + 1;
    }
  });
  return players;
}

export const getHighestScores = players => {
  return players
    .filter(p => p.score === players[0].score)
    .map(p => p.score);
}

export function getTopPlayers(topCount, urlGameCode) {
  console.log('topCount: ', topCount);
  console.log('urlGameCode: ', urlGameCode);

  const storedLocalData = JSON.parse(localStorage.getItem(urlGameCode + '_data'));
  const storedReadyPlayers = storedLocalData && storedLocalData.readyPlayers;

  const playersCopy = storedReadyPlayers.map(player => {
    return { ...player };
  });

  // Sort players by score
  const sortedPlayers = playersCopy.slice().sort((a, b) => b.score - a.score);

  // Rank players
  sortedPlayers.forEach((player, index) => {
    player.rank = index + 1;
  });

  // Group ranks if tie
  for (let i = 0; i < sortedPlayers.length; i++) {
    if (i > 0 && sortedPlayers[i].score === sortedPlayers[i - 1].score) {
      sortedPlayers[i].rank = sortedPlayers[i - 1].rank;
    }
  }

  // Filter to top ranks
  const topRankedPlayers = sortedPlayers
    .filter(p => p.rank <= topCount)
    .map(p => ({ ...p })); // copy player objects

  return topRankedPlayers;

}

export function getTopPlayersWithBadges(topCount, urlGameCode) {
  return getTopPlayers(topCount, urlGameCode).map(player => ({
    ...player,
    badge: String(player.rank)
  }));
}

export function getFirstPlaceFinishMessage(urlGameCode) {

  // Get top players 
  const topPlayers = getTopPlayers(1, urlGameCode);

  // Get top ranked players with rank 1
  const topRanked = topPlayers.filter(p => p.rank === 1);

  let message;

  if (topRanked.length === 1) {
    // One top ranked player
    const name = topRanked[0].name;
    message = `Your winner is ${name}`;
  } else {
    // Multiple top ranked players; get names
    const names = topRanked.map(p => p.name).join(' & ');
    message = `Your winners are ${names}`;
  }

  return message;
}
